import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { GetStore ,GetSessionStore} from "../services/comment";
@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.css"]
})
export class NotFoundComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    let loginSotre = JSON.parse(GetSessionStore("successLoginInfo"));
    if (loginSotre) {
      this.router.navigate(["main"]);
    } else {
      window.location.href = "/";
    }
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/not-found/not-found.component.ts